import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: 'my-token',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  private baseUrl: string;

  constructor(
    private httpClient: HttpClient,
    private cookieService: CookieService,
  ) {
    this.baseUrl = environment.baseApiURL;
  }

  public get<T>(endPoint: string) {
    return this.httpClient.get<T>(`${this.baseUrl}${endPoint}`);
  }
  public getWithParams<T>(endPoint: string, params?: any) {
    return this.httpClient.get<T>(`${this.baseUrl}${endPoint}`, { params: params });
  }
  public post<T>(endPoint: string, data: object, formData?: boolean) {
    if (formData) {
      httpOptions.headers.set('Content-type', 'multipart/form-data');
    }
    return this.httpClient.post<T>(`${this.baseUrl}${endPoint}`, data, httpOptions);
  }

  public put<T>(endPoint: string, data?: object) {
    return this.httpClient.put<T>(`${this.baseUrl}${endPoint}`, data);
  }
  /**
   * @param headers Optional per-request headers. Only additive — deliberately does not touch the
   *                shared module-level `httpOptions` that `post()` mutates.
   */
  public patch<T>(endPoint: string, data?: object, headers?: Record<string, string>) {
    return this.httpClient.patch<T>(`${this.baseUrl}${endPoint}`, data, headers ? { headers: new HttpHeaders(headers) } : undefined);
  }
  public delete<T>(endPoint: string) {
    return this.httpClient.delete<T>(`${this.baseUrl}${endPoint}`);
  }
}
